import UploadForm from "../components/UploadForm";
import LogoutButton from "../components/LogoutButton";
import "../App.css";
import logo from "../logo.svg";


export default function HomePage() {
    return (
        <div className="App">
           
                  <header className="App-header">
                  <div className="flex justify-end w-full">
                    <LogoutButton />
                    </div>
                    <img src={logo} className="App-logo" alt="logo" />
                    <h1>
                      Eko-bazaar Content Editor: use Tailwind CSS classes to
                      style elements
                    </h1>
                    <p>
                      Available animations: animate-pulse, animate-glow,
                      animate-float
                    </p>
                    <p>Go crazy</p>

                  </header>
                  
                  <div className="">
                    <UploadForm />
                  </div>
                </div>
    )
}